import React from "react";
import {
  DropdownTriggerProps,
  DropdownTriggerContentProps
} from "./Dropdown.types";
import * as S from "./Trigger.styles";

/**
 * Trigger component for the Dropdown menu
 *
 * @param props - The component props
 * @returns A Dropdown Trigger component
 */
export const Trigger = React.forwardRef<
  HTMLButtonElement,
  DropdownTriggerProps
>(function Trigger({ children, variant, $isActive, disabled, ...props }, ref) {
  return (
    <S.Trigger
      variant={variant}
      $isActive={$isActive}
      disabled={disabled}
      {...props}
      ref={ref}
    >
      {children}
    </S.Trigger>
  );
});

/**
 * Chevron icon component for the Dropdown Trigger
 *
 * @param props - The component props
 * @returns A Dropdown Chevron component
 */
export const Chevron = (
  props: Omit<React.ComponentProps<typeof S.Chevron>, "direction">
) => <S.Chevron {...props} />;

/**
 * Image component for the Dropdown Trigger
 *
 * @param props - The component props
 * @returns A Dropdown Image component
 */
export const Image = (props: React.ImgHTMLAttributes<HTMLImageElement>) => (
  <S.Image {...props} />
);

/**
 * TriggerContent component for the Dropdown Trigger
 *
 * @param props - The component props
 * @returns A Dropdown TriggerContent component
 */
export const TriggerContent: React.FC<DropdownTriggerContentProps> = ({
  children,
  border,
  onClick,
  ...props
}) => (
  <S.TriggerContent border={border} {...props}>
    {children}
  </S.TriggerContent>
);

/**
 * TriggerLabel component for the Dropdown Trigger
 *
 * @param props - The component props
 * @returns A Dropdown TriggerLabel component
 */
export const TriggerLabel = (props: React.HTMLAttributes<HTMLSpanElement>) => (
  <S.TriggerLabel {...props} />
);

/**
 * TriggerName component for the Dropdown Trigger
 *
 * @param props - The component props
 * @returns A Dropdown TriggerName component
 */
export const TriggerName = (props: React.HTMLAttributes<HTMLSpanElement>) => (
  <S.TriggerName {...props} />
);
